import React from 'react';
import { object } from 'prop-types';

import EventsList from '../../container/EventsList';

function NewEventsScene({ authUser, ...props }) {
  if (!authUser) return null;

  return (
    <EventsList authUser={authUser} {...props} />
  );
}

NewEventsScene.propTypes = {
  authUser: object,
};

export { NewEventsScene };
